import { APIDelete, APIGet, APIPost, APIPut, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { IStaffAccountShift } from "redux/reducers/models/shift";

export async function GetShifts(
  params: {
    date: string;
    kitchen_percent?: number;
    bar_percent?: number;
    support_percent?: number;
    staff_ids: number[];
    suppress_print: boolean;
  },
  useGlobalLoader?: boolean,
) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/client/admin/shift-summary"), params, useGlobalLoader);
}

export async function GetStaffAccountShift(useGlobalLoader?: boolean, cancelToken?: CancelToken) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/client/admin/shift"), null, useGlobalLoader, cancelToken);
}

export async function GetStaffAccountShiftsAll(
  params: { user_id: number; limit?: number; offset?: number; filters?: Array<{ label: string; value: any }> },
  useGlobalLoader?: boolean,
  cancelToken?: CancelToken,
) {
  return await APIGet<IStaffAccountShift[]>(
    APIUrl(AdminType.FacilityAdmin, "/client/admin/shift/all"),
    params,
    useGlobalLoader,
    cancelToken,
  );
}

export async function PostStaffAccountShiftClockIn(
  params: { notes?: string; longitude?: number; latitude?: number; role_id?: number },
  useGlobalLoader?: boolean,
) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/client/admin/shift/clock-in"), params, useGlobalLoader);
}

export async function PutStaffAccountShiftClockOut(params: { notes?: string }, useGlobalLoader?: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/client/admin/shift/clock-out"), params, useGlobalLoader);
}

export async function PutStaffAccountShift(
  params: { id: number; clock_in_at?: string; clock_out_at?: string; notes?: string; role_id?: number },
  useGlobalLoader?: boolean,
) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/client/admin/shift"), params, useGlobalLoader);
}

interface IPostStaffAccountShift {
  user_id: number;
  clock_in_at: string;
  clock_out_at: string;
  notes?: string;
  role_id?: number;
}

export async function PostStaffAccountShift(params: IPostStaffAccountShift, useGlobalLoader?: boolean) {
  return await APIPost<IStaffAccountShift>(
    APIUrl(AdminType.FacilityAdmin, "/client/admin/shift"),
    params,
    useGlobalLoader,
  );
}

interface IDeleteStaffAccountShift {
  id: number;
}

export async function DeleteStaffAccountShift(params: IDeleteStaffAccountShift, useGlobalLoader?: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/client/admin/shift"), params, useGlobalLoader);
}
